/***********************************************************************
 * Copyright (c) 2018 Charles W. Roberts
 * All Rights Reserved
 *
 * No portion of this code may be copied or modified without the
 * prior written permission of Charles Roberts.
 *
 ***********************************************************************/
/**
* @file Contains the class definition of the SlidingCarousel react
* component class.  
* @author Charles Roberts
* @copyright Charles Roberts 2018
*/

import React from "react";
import "./SlidingCarousel.css";

/**
 * @classdesc The Fading-Carousel class creates objects that are react
 * components.  Fading Carousel objects have a number of divs one on top
 * of the other with only one div visible.
 */
class SlidingCarousel extends React.Component {

  constructor(props) {
    console.log("I'm a sliding carousel.  My name is " + props.name);
    console.log("The number of slides is " + props.componentArray.length);
    super(props);

    this.state =
      {
        name: props.name,
        slideCount: props.componentArray.length,
        activeIndex: 0

      }

  } // End of constructor()

  setActiveScreen = (screenIn) =>
  {
    this.setState( {activeIndex: screenIn});
  }

  onNextClick = (event) => {
    console.log("I'm in onNextClick. slideCount is " + this.state.slideCount - 1);
    console.log("My name is " + this.props.name);
    console.log("my ref is ");
    console.log(this.refs)
    console.log(this);
    console.log(event.nativeEvent);
    /* In the conditional below, the number is the number of slides minus one */
    if (this.state.activeIndex < this.state.slideCount - 1) {
      this.setState({ activeIndex: this.state.activeIndex + 1 });

    }
  } // End of onNextClick()

  onFirstClick = (event) => {
    console.log("I'm in onFirstClick");
    console.log("My name is " + this.state.name);
    console.log(this);
    console.log("event.target is ");
    console.log(event.target);
    this.setState({ activeIndex: 0 });
  }

  onLastClick = (event) => {
    console.log("I'm in onLastClick");
    console.log("My name is " + this.state.name);
    this.setState({ activeIndex: this.state.slideCount - 1 });
    console.log("My id is " + event.target.id);

  } // End of onNextClick()

  onPrevClick = (event) => {
    console.log("I'm in onPrevClick");
    console.log("My name is " + this.state.name);
    console.log(event.target.myname);
    if (this.state.activeIndex > 0) {
      this.setState({ activeIndex: this.state.activeIndex - 1 });

    }
  } // End of onPrevClick

  componentDidMount = () => {
    console.log(`${this.props.name} did mount.`);
  }

  componentWillUnmount = () => {
    console.log(`${this.props.name} will unmount.`);
  }


  renderButtons = () => {
    let buttonStyle =
      {
        className: `${this.state.name}`
      }

    if (this.state.slideCount > 1) {
      return (
        <div className='moveButtons'>
          <button onClick={this.onFirstClick} style={buttonStyle}>|◀</button>
          <button onClick={this.onPrevClick} style={buttonStyle}>◀</button>
          <button onClick={this.onNextClick} style={buttonStyle}>▶</button>
          <button onClick={this.onLastClick} style={buttonStyle}>▶|</button>
        </div>
      )
    }
  }

  render() {

    /* The percentage in the line below is 100% divided by the number of slides*/
    let sliderStyle =
      {
        transform: `translateX(${this.state.activeIndex * -12.5}%)`,
        transition: '0.33s'
      }

    console.log(`In render, the name is ${this.state.name}`);

    return (
      <div>

        <div className='sc_component_frame'>

          <div className='sc_slide_carousel' style={sliderStyle}>


            <div className='sc_slide-holder'>
              <div className='sc_slide'>
                {this.props.componentArray[0]}
              </div>
            </div>

            <div className='sc_slide-holder'>
              <div className='sc_slide'>
                {this.props.componentArray[1]}
              </div>
            </div>

            <div className='sc_slide-holder'>
              <div className='sc_slide'>
                {this.props.componentArray[2]}
              </div>
            </div>

            <div className='sc_slide-holder'>
              <div className='sc_slide'>
                {this.props.componentArray[3]}
              </div>
            </div>

            <div className='sc_slide-holder'>
              <div className='sc_slide'>
                {this.props.componentArray[4]}
              </div>
            </div>

            <div className='sc_slide-holder'>
              <div className='sc_slide'>
                {this.props.componentArray[5]}
              </div>
            </div>

            <div className='sc_slide-holder'>
              <div className='sc_slide'>
                {this.props.componentArray[6]}
              </div>
            </div>

            <div className='sc_slide-holder'>
              <div className='sc_slide'>
                {this.props.componentArray[7]}
              </div>
            </div>

          </div>

        </div>

        <div className='sc_buttons'>

          {this.renderButtons()}

        </div>


      </div>

    );

  } // End of render() method

} // End of class SlidingCarousel 

export default SlidingCarousel;



// WEBPACK FOOTER //
// ./src/components/SlidingCarousel/SlidingCarousel.js